import React, {Component} from 'react';
import {Checkbox, InputItem, Modal, NavBar, Toast} from 'antd-mobile';
import BMap from "BMap";
import AgreementModal from "../../../components/AgreementModal";
import {connect} from "react-redux";
import {getOftenList} from "../../../service/memberService";
import PayModal from "../../../components/PayModal";
import ReconnectingWebSocket  from 'reconnecting-websocket';
import {
    couponlistperson,
    addOrder,
    cancelCityOrder,
    cityOrderType,
    getCancelPic,
    cityWxPay,
    getShuttlePrice,
    shuttleSubmit,
    shuttlePay,txdirection
} from "../../../service/homeService";
import "./style.less";
import {wss} from "../../../config/config";
import moment from "moment";
const driverPhone = require('../../../common/image/driverPhone.png');
const CheckboxItem = Checkbox.CheckboxItem;
let map;
let isSubmit = false;
let timer = "";
let rws = null;
let socketTime = "";
@connect(
    state => ({userInfo: state.userInfo})
)
export default class RideCar extends Component {
    constructor(props) {
        super(props);
        if (isSubmit) {
            isSubmit = false;
            props.history.go(-2);
        }
        this.state = {
            agreementModal:false,//用户协议modal
            selPsgModal:false,
            position:{top:0,left:0},
            userPoint:'',
            rideModal:false,//常用乘车人modal
            name:"",
            phone:"",
            psgData:[],
            mapLoad:false,//判断加载地图全屏
            countDown:"",//倒计时秒数
            integralVal:false,//是否使用积分
            discountsModal:false,//优惠券modal
            discountList:[],//优惠券列表数据
            cayStatus:-2,//订单状态:0-未接单1-已接单2-开始接人3-已到达上车地点4-确认上车5-行程中6-行程结束,待发送账单7-账单已发送，待乘客支付8-乘客已支付97-滞留订单98-已锁定99-已取消
            cityDetail:"",
            cityOrderid:"",
            totalPrice:0,
            integralPrice:0,
            socket:false,
            loginSocket:false,
            payModal:false,
            formPay:"",
            orderType:"",
            phoneModal:false,
            carType:['A级豪华','B级轻奢','商务车','经济型','简约型'],
            tabIndex:0,
            phoneVal:"",
            runOrderid: "",
            corderId:"",
        };
    }

    componentDidMount() {
        Toast.hide();
        let props = this.props.location.state;
        if(props && props.runType == 0){
            this.loadMap(props.siteDate,props.address);
            this.getRunPrice();
        }else if(props && props.runType == 1){
            this.loadMap(props.address,props.siteDate);
            this.getRunPrice();
        }else{
            if(props && !props.orderId){
                this.loadMap(props.startPosition,props.endPosition);
                this.getOftenList(props);
                this.setState({cayStatus:-1})
            }else{
                clearInterval(socketTime);
                this.getOrderStatus("call",props,);
            }
        }
    }
    getRunPrice(){
        let props = this.props.location.state;
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                stationId:props.siteDate.id,
                location:props.address.lat + '_' + props.address.lng,
                startTimeStr:moment(props.appointmentTime).format('YYYY-MM-DD HH:mm')
            }
        };
        getShuttlePrice(params).then((res)=>{
            if(res.data.code == '0000') {
                this.setState({carType:res.data.data})
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    getOrderStatus(type,props,){
        clearInterval(socketTime);
        Toast.loading("",30);
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                id:props && props.orderId ?  props.orderId : this.state.corderId,
            }
        };
        cityOrderType(params).then((res)=>{
            if(res.data.code == '0000'){
                Toast.hide();
                clearInterval(timer);
                if(res.data.data == false){
                    this.loadMap(props.startPosition,props.endPosition);
                    this.getOftenList(props);
                    this.setState({cayStatus:-1})
                }else{
                    if(props !== undefined && !res.data.data.isTwice && (props.nowType !== res.data.data.cityOrderType) && props.orderId == undefined){
                        this.loadMap(props.startPosition,props.endPosition);
                        this.getOftenList(props);
                        this.setState({cayStatus:-1})
                    }else{
                        let data={
                            "command":"login",
                            "data":{
                                "id":this.props.userInfo.userId,
                            }
                        };
                        //根据状态是否启用websocket
                        if((res.data.data.orderStatus !== 7 && res.data.data.orderStatus !== 99) && type == "call" ){
                            this.initWebsocket(JSON.stringify(data));
                        }
                        let startPosition = {
                            lng:res.data.data.startAddressLocation.split("_")[1],
                            lat:res.data.data.startAddressLocation.split("_")[0],
                        };
                        let endPosition = {
                            lng:res.data.data.endAddressLocation.split("_")[1],
                            lat:res.data.data.endAddressLocation.split("_")[0],
                        };
                        this.loadMap(startPosition,endPosition);
                        this.setState({
                            cityDetail:res.data.data,
                            cityOrderid:res.data.data.id,
                            totalPrice:res.data.data.price,
                        });
                        if(res.data.data.payStatus==0){
                            this.setState({cayStatus:7})
                            res.data.data.discount = 0;
                            res.data.data.stars = 4.6;
                            let discountParams = {
                                source: 1,
                                token:this.props.userInfo.token,
                                data:{
                                    lineId:res.data.data.cityId,
                                    couponOrderType:1,
                                },
                            };
                            couponlistperson(discountParams).then((n)=>{
                                if(n.data.code === '0000'){
                                    this.setState({discountList:n.data.data})
                                    //优惠券默认最大优惠
                                    let discountPic = [];
                                    let discountRatio  = [];
                                    let newDiscount = [];
                                    let max = 0;
                                    n.data.data.map((n,discountIndex)=>{
                                        //使用限制不管是限制还是满减只要票价格小于等于满减金额当前优惠券就可以用
                                        if(res.data.data.price >= n.useLimitAmount){
                                            //如果是固定金额
                                            if(n.couponType == 1){
                                                //优惠总价低于票价的50%，直接抵扣优惠金额
                                                if(res.data.data.price/2 >= n.couponAmount){
                                                    //r.totalPrice - res.couponAmount :票价-优惠价格 = 实际支付价格
                                                    //res.couponAmount:实际优惠价格
                                                    discountPic.push({pic:n.couponAmount,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                                                }
                                                //优惠总价高于票价的50%，抵扣票价金额的50%
                                                if(res.data.data.price/2 < n.couponAmount){
                                                    discountPic.push({pic:res.data.data.price/2,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                                                }
                                            }
                                            //如果是固定比例
                                            if(n.couponType == 2){
                                                discountRatio.push({pic:res.data.data.price*n.discountRatio,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                                            }
                                        }
                                    });
                                    newDiscount =discountPic.concat(discountRatio);
                                    for (let i=0;i<newDiscount.length;i++){
                                        if(newDiscount[max].pic <= newDiscount[i].pic){
                                            max = i
                                        }
                                    }
                                    if(newDiscount.length > 0){
                                        res.data.data.discount = parseFloat(newDiscount[max].pic.toFixed(2));
                                        res.data.data.discountId = newDiscount[max].id;
                                        res.data.data.couponName = newDiscount[max].couponName;
                                    }
                                    let totalPrice = parseFloat((res.data.data.price-res.data.data.discount).toFixed(2));
                                    let integralFlag = [];
                                    integralFlag.push(res.data.data.integral,totalPrice,res.data.data.integralCount,);
                                    integralFlag.sort(function (a, b) {
                                        return a-b;
                                    });
                                    res.data.data.integralPic =Math.ceil(integralFlag[0]);//抵扣的积分
                                    this.setState({
                                        totalPrice:parseFloat((res.data.data.price-res.data.data.discount).toFixed(2)),
                                    });
                                }else{
                                    Toast.info(res.data.msg)
                                }
                            });
                            return;
                        }
                        if(res.data.data.cityOrderType == 1 && res.data.data.orderStatus > 1){
                            this.setState({cayStatus:res.data.data.orderStatus,});
                        }
                        if(res.data.data.cityOrderType == 0){
                            this.setState({cayStatus:res.data.data.orderStatus,});
                        }
                        if(res.data.data.orderStatus == 0 && res.data.data.cityOrderType == 0){
                            let timestamp = (new Date()).getTime();
                            let timeArea = moment(res.data.data.timeStamp).add((res.data.data.waitMinutes+1)*60, 'seconds').format('x') - timestamp;
                            if(timeArea > 0){
                                this.setDownTime(parseInt(timeArea / 1000),res.data.data.id);
                            }else{
                                Toast.info("超过等待时间",3)
                            }
                        }
                        if(res.data.data.orderStatus == 7 || res.data.data.orderStatus == 8){
                            // res.data.data.discount = 0;
                            // res.data.data.stars = 4.6;
                            // let discountParams = {
                            //     source: 1,
                            //     token:this.props.userInfo.token,
                            //     data:{
                            //         lineId:res.data.data.cityId,
                            //         couponOrderType:1,
                            //     },
                            // };
                            // couponlistperson(discountParams).then((n)=>{
                            //     if(n.data.code === '0000'){
                            //         this.setState({discountList:n.data.data})
                            //         //优惠券默认最大优惠
                            //         let discountPic = [];
                            //         let discountRatio  = [];
                            //         let newDiscount = [];
                            //         let max = 0;
                            //         n.data.data.map((n,discountIndex)=>{
                            //             //使用限制不管是限制还是满减只要票价格小于等于满减金额当前优惠券就可以用
                            //             if(res.data.data.price >= n.useLimitAmount){
                            //                 //如果是固定金额
                            //                 if(n.couponType == 1){
                            //                     //优惠总价低于票价的50%，直接抵扣优惠金额
                            //                     if(res.data.data.price/2 >= n.couponAmount){
                            //                         //r.totalPrice - res.couponAmount :票价-优惠价格 = 实际支付价格
                            //                         //res.couponAmount:实际优惠价格
                            //                         discountPic.push({pic:n.couponAmount,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                            //                     }
                            //                     //优惠总价高于票价的50%，抵扣票价金额的50%
                            //                     if(res.data.data.price/2 < n.couponAmount){
                            //                         discountPic.push({pic:res.data.data.price/2,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                            //                     }
                            //                 }
                            //                 //如果是固定比例
                            //                 if(n.couponType == 2){
                            //                     discountRatio.push({pic:res.data.data.price*n.discountRatio,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                            //                 }
                            //             }
                            //         });
                            //         newDiscount =discountPic.concat(discountRatio);
                            //         for (let i=0;i<newDiscount.length;i++){
                            //             if(newDiscount[max].pic <= newDiscount[i].pic){
                            //                 max = i
                            //             }
                            //         }
                            //         if(newDiscount.length > 0){
                            //             res.data.data.discount = parseFloat(newDiscount[max].pic.toFixed(2));
                            //             res.data.data.discountId = newDiscount[max].id;
                            //             res.data.data.couponName = newDiscount[max].couponName;
                            //         }
                            //         let totalPrice = parseFloat((res.data.data.price-res.data.data.discount).toFixed(2));
                            //         let integralFlag = [];
                            //         integralFlag.push(res.data.data.integral,totalPrice,res.data.data.integralCount,);
                            //         integralFlag.sort(function (a, b) {
                            //             return a-b;
                            //         });
                            //         res.data.data.integralPic =Math.ceil(integralFlag[0]);//抵扣的积分
                            //         this.setState({
                            //             totalPrice:parseFloat((res.data.data.price-res.data.data.discount).toFixed(2)),
                            //         });
                            //     }else{
                            //         Toast.info(res.data.msg)
                            //     }
                            // });
                        }
                    }

                }
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    getOrderStatus2(data){
        var res = {
            data:{
                data:""
            }
        };
        res.data.data=data;
        if(!res.data.data){
            // clearInterval(_this.timeNumber);
            // _this.timeNumber = null;
            // _this.$mHelper.toast('订单已取消');
            setTimeout(function(){
                this.props.history.goBack();
            },1500)
            return;
        }
        let startPosition = {
            lng:res.data.data.startAddressLocation.split("_")[1],
            lat:res.data.data.startAddressLocation.split("_")[0],
        };
        let endPosition = {
            lng:res.data.data.endAddressLocation.split("_")[1],
            lat:res.data.data.endAddressLocation.split("_")[0],
        };
        this.loadMap(startPosition,endPosition);
        this.setState({
            cityDetail:res.data.data,
            cityOrderid:res.data.data.id,
            totalPrice:res.data.data.price,
        });
        if(res.data.data.payStatus==0){
            this.setState({cayStatus:7})
            res.data.data.discount = 0;
            res.data.data.stars = 4.6;
            let discountParams = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    lineId:res.data.data.cityId,
                    couponOrderType:1,
                },
            };
            couponlistperson(discountParams).then((n)=>{
                if(n.data.code === '0000'){
                    this.setState({discountList:n.data.data})
                    //优惠券默认最大优惠
                    let discountPic = [];
                    let discountRatio  = [];
                    let newDiscount = [];
                    let max = 0;
                    n.data.data.map((n,discountIndex)=>{
                        //使用限制不管是限制还是满减只要票价格小于等于满减金额当前优惠券就可以用
                        if(res.data.data.price >= n.useLimitAmount){
                            //如果是固定金额
                            if(n.couponType == 1){
                                //优惠总价低于票价的50%，直接抵扣优惠金额
                                if(res.data.data.price/2 >= n.couponAmount){
                                    //r.totalPrice - res.couponAmount :票价-优惠价格 = 实际支付价格
                                    //res.couponAmount:实际优惠价格
                                    discountPic.push({pic:n.couponAmount,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                                }
                                //优惠总价高于票价的50%，抵扣票价金额的50%
                                if(res.data.data.price/2 < n.couponAmount){
                                    discountPic.push({pic:res.data.data.price/2,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                                }
                            }
                            //如果是固定比例
                            if(n.couponType == 2){
                                discountRatio.push({pic:res.data.data.price*n.discountRatio,id:n.id,discountIndex:discountIndex,couponName:n.couponName})
                            }
                        }
                    });
                    newDiscount =discountPic.concat(discountRatio);
                    for (let i=0;i<newDiscount.length;i++){
                        if(newDiscount[max].pic <= newDiscount[i].pic){
                            max = i
                        }
                    }
                    if(newDiscount.length > 0){
                        res.data.data.discount = parseFloat(newDiscount[max].pic.toFixed(2));
                        res.data.data.discountId = newDiscount[max].id;
                        res.data.data.couponName = newDiscount[max].couponName;
                    }
                    let totalPrice = parseFloat((res.data.data.price-res.data.data.discount).toFixed(2));
                    let integralFlag = [];
                    integralFlag.push(res.data.data.integral,totalPrice,res.data.data.integralCount,);
                    integralFlag.sort(function (a, b) {
                        return a-b;
                    });
                    res.data.data.integralPic =Math.ceil(integralFlag[0]);//抵扣的积分
                    this.setState({
                        totalPrice:parseFloat((res.data.data.price-res.data.data.discount).toFixed(2)),
                    });
                }else{
                    Toast.info(res.data.msg)
                }
            });
            return;
        }
        if(res.data.data.cityOrderType == 1 && res.data.data.orderStatus > 1){
            this.setState({cayStatus:res.data.data.orderStatus,});
        }
        if(res.data.data.cityOrderType == 0){
            this.setState({cayStatus:res.data.data.orderStatus,});
        }
        if(res.data.data.orderStatus == 0 && res.data.data.cityOrderType == 0){
            let timestamp = (new Date()).getTime();
            let timeArea = moment(res.data.data.timeStamp).add((res.data.data.waitMinutes+1)*60, 'seconds').format('x') - timestamp;
            if(timeArea > 0){
                this.setDownTime(parseInt(timeArea / 1000),res.data.data.id);
            }else{
                Toast.info("超过等待时间",3)
            }
        }
        if(res.data.data.orderStatus == 7 || res.data.data.orderStatus == 8){
               Toast.info("订单结束",2,()=>{this.props.history.push("/gradeDriver",this.state.cityDetail)});
        }
    }
    initWebsocket(obj){
        if(!rws){
            rws  =  new  ReconnectingWebSocket(wss);
        }
        rws.addEventListener("open", async () => {
            if (!rws) return;
            if (rws.readyState === 1) {
                // 这个是你给websocket 传输它要的东西
                rws.send(obj);
            }
        });
        let beatData={
            "command":"beat",
            "data":{
                "id":this.props.userInfo.userId,
            }
        };
        let data={
            "command":"login",
            "data":{
                "id":this.props.userInfo.userId,
            }
        };
        rws.addEventListener("message", e => {
            // 这里是你拿到数据后进行的处理
            //你可以调用action 来触发消息给页面上展示 例如 这些消息方法需要你自己来封装
            let data = JSON.parse(e.data);
            console.log("585接收到的",data);
            if(data.code == 200 && data.command == 'login'){
                this.setState({loginSocket:true});
                // socketTime = setInterval(()=>{
                //     this.initWebsocket(JSON.stringify(beatData));
                // },180000);
            }
            if (data.code == 200 && data.command !== 'login' && data.command !== 'beat'){
                // this.getOrderStatus();
                let getdata = {
                    command: 'status',
                    msgId:data.msgId
                };
                console.log(482,JSON.stringify(getdata));
                rws.send(JSON.stringify(getdata))
                this.getOrderStatus2(data.data);
            }
            if(data.code == 200 && data.command == 'beat'){
                this.setState({socket:true});
            }
            // if(data.code == 200 && data.command == 'status'){
            //     this.setState({socket:true});
            // }  
        });
        if(JSON.parse(obj).command == 'login' ){
            setTimeout(()=>{
                if(!this.state.loginSocket){
                    rws.send(JSON.stringify(data));
                }
            },10000)
        }
        if(JSON.parse(obj).command == 'beat' ){
            setTimeout(()=>{
                if(!this.state.socket){
                    rws.send(JSON.stringify(data));
                }
            },10000)
        }
        // 关闭时进行的操作
        // rws.addEventListener("close", () => {
        //     rws = null;
        //     console.info("服务断开连接。");
        // });
    }
    loadMap(starVal,endVal){
        if(map){
            map.destroy();
        }
        let center = new window.TMap.LatLng(endVal.lat, endVal.lng)
        map = new window.TMap.Map('mapContainer',{center: center,zoom:11,
            offset: { // 中心点偏移
                x: 0,
                y: -100,
            }
        });
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.SCALE);
        let bounds = new window.TMap.LatLngBounds();
        if(bounds.isEmpty() || !bounds.contains(new window.TMap.LatLng(starVal.lat, starVal.lng))){
            bounds.extend(new window.TMap.LatLng(starVal.lat, starVal.lng));
        }
        if(bounds.isEmpty() || !bounds.contains(center)){
            bounds.extend(center);
        }
        // 设置地图可视范围
        map.fitBounds(bounds, { padding: 80 });// 自适应边距
        let params = {
            source: 1,
            token: this.props.userInfo.token,
            data:{from:starVal.lat+','+starVal.lng,to:endVal.lat+','+endVal.lng}
        };
        txdirection(params).then((res)=>{
            console.log(res.data.data.result.routes[0])
            let data = res.data.data.result.routes[0]
            setTimeout(()=>{
                this.setState({mapLoad:true})
            },500);
            var coors = data.polyline, pl = [];
            //坐标解压（返回的点串坐标，通过前向差分进行压缩，因此需要解压）
            var kr = 1000000;
            for (var i = 2; i < coors.length; i++) {
            coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr;
            }
            //将解压后的坐标生成LatLng数组
            for (var i = 0; i < coors.length; i += 2) {
                pl.push(new window.TMap.LatLng(coors[i], coors[i+1]));
            }          

            var polylineLayer = new window.TMap.MultiPolyline({
                id: 'polyline-layer', //图层唯一标识
                map: map,//绘制到目标地图
                //折线样式定义
                styles: {
                    'style_blue': new window.TMap.PolylineStyle({
                        'color': '#3679FE', //线填充色
                        'width': 6, //折线宽度
                        'borderWidth': 2, //边线宽度
                        'borderColor': '#FFF', //边线颜色
                        'lineCap': 'round' //线端头方式
                    })
                },
                //折线数据定义
                geometries: [
                    {
                        'id': 'pl_1',//折线唯一标识，删除时使用
                        'styleId': 'style_blue',//绑定样式名
                        'paths': pl
                    }
                ]
            });
            //标记起终点marker
            var marker = new window.TMap.MultiMarker({ 
                id: 'marker-layer',
                map: map,
                styles: {
                    "start": new window.TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": { x: 16, y: 32 },
                        "src": 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png'
                    }),
                    "end": new window.TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": { x: 16, y: 32 },
                        "src": 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png'
                    })
                },
                geometries: [{
                    "id": 'start',
                    "styleId": 'start',
                    "position": new window.TMap.LatLng(starVal.lat,starVal.lng)
                }, {
                    "id": 'end',
                    "styleId": 'end',
                    "position": new window.TMap.LatLng(endVal.lat,endVal.lng)
                }]
            });
            var infoWindow = new window.TMap.InfoWindow({
                map: map,
                enableCustom: true,
                position: new window.TMap.LatLng(endVal.lat, endVal.lng),
                offset: { y: -28, x: 0 },
                content:
                    `<div class="info_card">全程`+(data.distance/1000).toFixed(2)+`公里</div>`,
            });
        })
        
        // map = new BMap.Map('mapContainer');
        // let p1 = new BMap.Point(starVal.lng,starVal.lat);
        // let p2 = new BMap.Point(endVal.lng,endVal.lat);
        // map.centerAndZoom(p1, 15);
        // let output = "全程";
        // let searchComplete = (results)=>{
        //     if (driving.getStatus() !== 0){
        //         return ;
        //     }
        //     let plan = results.getPlan(0);
        //     output += plan.getDistance(true); //获取距离
        //     setTimeout(()=>{
        //         this.setState({mapLoad:true})
        //     },500);
        // };
        // let driving = new BMap.DrivingRoute(map, {renderOptions:{map: map, autoViewport: true},
        //     onSearchComplete: searchComplete,
        //     onPolylinesSet: function(){
        //         setTimeout(()=>{
        //             let opts = {
        //                 position : p2 ,    // 指定文本标注所在的地理位置
        //                 offset   : new BMap.Size(-54, -52)    //设置文本偏移量
        //             };
        //             let label = new BMap.Label(output, opts);  // 创建文本标注对象
        //             label.setStyle({
        //                 paddingLeft:"16px",
        //                 paddingRight:"16px",
        //                 textAlign:"center",
        //                 border:"none",
        //                 borderRadius:"20px",
        //                 color : "#616372",
        //                 fontSize : "16px",
        //                 fontWeight:"bold",
        //                 height : "32px",
        //                 lineHeight : "32px",
        //                 fontFamily:"微软雅黑"
        //             });
        //             map.addOverlay(label);
        //         },1000);
        //     }
        // });
        // driving.search(p1, p2);
        // let startIcon = new BMap.Icon(require('../../../common/image/startIcon.png'),new BMap.Size(32,44),);
        // let endIcon = new BMap.Icon(require('../../../common/image/endIcon.png'),new BMap.Size(32,44));
        // driving.setMarkersSetCallback((result)=>{
        //     result[0].marker.setIcon(startIcon);
        //     result[1].marker.setIcon(endIcon)
        // });
    }
    onClose = key => () => {
        this.setState({[key]: false});
    };
    agreementClose=()=>{
        this.setState({agreementModal:false});
    };
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    getOftenList(){
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {pageSize:100, pageNum:1}
        };
        //获取常用联系人
        getOftenList(params).then((res) => {
            if (res.data.code === '0000') {
                res.data.data.list.map((res)=>{
                    if(res.idType == 'idcard'){
                        res.numSelected = '身份证'
                    }
                    if(res.idType == 'passport'){
                        res.numSelected = '护照'
                    }
                    if(res.idType == 'borderCard'){
                        res.numSelected = '边民证'
                    }
                });
                this.setState({psgData: res.data.data.list,});
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    selPsg(){
        return(
            <Modal
                className="selPsgModal"
                animationType="slide-up"
                popup
                maskClosable={false}
                visible={this.state.selPsgModal}
                onClose={this.onClose('selPsgModal')}
            >
                <div className="content">
                    <div className="top">
                        <div onClick={this.onClose('selPsgModal')}>取消</div>
                        <div style={{"paddingRight":"20px"}}>选择乘客</div>
                        <div></div>
                    </div>
                    <div className="box">
                        <p>支持上车携带身份证扫描完善</p>
                        {/*<div className="goAdd" onClick={()=>this.props.history.push('/addOftenPsg','perfection')}>
                            <i className="icon iconfont icontianjiala"/>
                            <span>添加常用乘车人</span>
                            <i className="icon iconfont icontiaozhuan"/>
                        </div>*/}
                        <div className="itemBox">
                            {
                                this.state.psgData == "" ?  <div>暂无常用乘车人</div> : (
                                    this.state.psgData.map((res,i) => (
                                        <div className="item"  key={i} onClick={()=>this.selPagOk(res)}>
                                            <div className="info">
                                                <span>{res.name}</span>
                                                <div className="">{res.numSelected} &nbsp;&nbsp;{res.idNum}</div>
                                            </div>
                                        </div>
                                    )
                                 ))
                            }
                        </div>

                    </div>
                </div>
            </Modal>
        )
    }
    selPagOk(res){
        this.setState({
            name:res.name,
            phone:res.phone,
            selPsgModal:false,
        });
    }
    submitInfo(){
        if(this.state.phone == ""){
            Toast.info("请输入手机号",2);
            return
        }
        this.goByCar()
    }
    goByCar(type){
        let props = this.props.location.state;
        console.log(457,this.state);
        console.log(458,props);
        if(type == "run"){
            let params = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    orderType:props.runType == 0 ? 1 : 2,
                    stationId:props.siteDate.id,
                    startTimeStr:moment(props.appointmentTime).format('YYYY-MM-DD HH:mm'),
                    orderSource:1,
                    phone:this.state.phoneVal == '' ? this.props.userInfo.phone : this.state.phoneVal,
                    vehicleModelId:this.state.carType[this.state.tabIndex].vehicleModelId,
                    price:this.state.carType[this.state.tabIndex].price,
                    startLocation:props.runType == 0 ? props.siteDate.lat + '_' + props.siteDate.lng : props.address.lat + '_' + props.address.lng,
                    endLocation:props.runType == 0 ? props.address.lat + '_' + props.address.lng: props.siteDate.lat + '_' + props.siteDate.lng ,
                    startAddress:props.runType == 0 ? props.siteDate.name : props.address.endAddress,
                    endAddress:props.runType == 0 ? props.address.endAddress : props.siteDate.name,
                    // isFirstPay:1,
                    // driverDistance:props.runType == 0 ? props.driverDistance:"",
                    // driverTime:props.runType == 0 ? props.driverTime:"",
                }
            };
            Toast.loading("",30);
            shuttleSubmit(params).then((res)=>{
                if(res.data.code == "0000"){
                    Toast.hide();
                    this.setState({payModal:true,runOrderid:res.data.data.orderId});
                }else{
                    Toast.info(res.data.msg)
                }
            })
        }else{
            let params = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    userName:this.state.name,
                    userPhone:this.state.phone,
                    cityorderType:props.nowType,
                    estimatedTimeOfDeparture:props.appointmentTime == '现在出发' ? '' : moment(props.appointmentTime).utcOffset(8).format(),
                    startAddress:props.startAddress,
                    startLocation:props.startPosition.lat+"_"+props.startPosition.lng,
                    endAddress:props.endAddress,
                    endLocation:props.endPosition.lat+"_"+props.endPosition.lng,
                    cityId:props.cityId,
                    theoryPrice:props.theoryPrice,
                    driverId:sessionStorage.getItem("codeId"),
                    isFirstPay:1,
                    driverDistance:props.driverDistance,
                    driverTime:props.driverTime,
                    startAddressCode:props.startAddressCode,
                    endAddressCode:props.endAddressCode,
                }
            };
            Toast.loading("",30);
            addOrder(params).then((res)=>{
                if(res.data.code == "0000"){
                    sessionStorage.removeItem("codeId");
                    Toast.hide();
                    if(props.nowType == 0){
                        this.setState({corderId:res.data.data.id})
                        this.getOrderStatus("call");
                    }else{
                        Toast.info("预约成功",2,()=>{this.props.history.go(-2);})
                    }
                    this.setState({rideModal:false});
                }else{
                    Toast.info(res.data.msg)
                }
            })
        }

    }
    cayStatus(){
        const props = this.props.location.state;
        if(this.state.cayStatus == -2){
            return null
        }
        if(this.state.cayStatus == 0){
            return(
                <div className="carCall">
                    <div className="title">正在找车...</div>
                    <div className="await">
                        剩余时间：<span>{moment(this.state.countDown * 1000).format("mm:ss")}</span>
                        <div className="animate">
                            <div className="animate-row">
                                <div className="behaviour beha1"></div>
                                <div className="behaviour beha2"></div>
                                <div className="behaviour beha3"></div>
                            </div>
                        </div>
                    </div>
                    <div className="btn" onClick={()=>Modal.alert('提示',
                        (<div style={{paddingTop:0}}>
                            <div style={{fontSize:16}}>您是否要取消订单？</div>
                        </div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"46px"}
                        }, {
                            text: '确认',
                            onPress: () => this.cancelCar(this.state.cityOrderid),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"46px"}
                        }]
                    )}><button>取消订单</button></div>
                </div>
            )
        }
        if(this.state.cayStatus == 1 || this.state.cayStatus == 2 || this.state.cayStatus == 3 || this.state.cayStatus == 4 || this.state.cayStatus == 6){
            return(
                <div className="carCall">
                    <div className="title">{this.state.cayStatus == 6 ? "待确认账单…" :this.state.cayStatus == 4 ? "行程中…" : "已接单…"}</div>
                    <div className="driver">
                        <div className="imgBox"><img src={driverPhone}/></div>
                        <div className="driverInfo">
                            <div>{this.state.cityDetail.carNum}</div>
                            <div>{this.state.cityDetail.driverName} <i className="icon iconfont iconpingfenxianshi" /><span>4.6</span> </div>
                            <div>{this.state.cityDetail.brand} {this.state.cityDetail.vehicleColor}</div>
                        </div>
                        <div>
                            <a href={`tel:${this.state.cityDetail.driverPhone}`}><i className="icon iconfont icondingdanxiangqingdianhua" /></a>
                            {/*<span onClick={()=>this.callPhone(this.props.location.state.id)}><i className="icon iconfont icondingdanxiangqingdianhua" /></span>*/}
                        </div>
                    </div>
                    {
                        this.state.cayStatus == 6 ? null : this.state.cayStatus == 4 ? "" :
                            <div className="btn" onClick={()=>this.getCancelPrice()}><button>取消订单</button></div>
                    }
                </div>
            )
        }
        if(this.state.cayStatus == 7){
            return(
                <div className="carCall">
                    <div className="title"></div>
                    <div className="content">
                        <p className="picText"><span className="pic">{this.state.totalPrice}</span> 元</p>
                        <p className="text">本次行程需支付</p>
                        <div className="discounts border">
                            <span>积分抵扣</span>
                            <span>{this.state.cityDetail.integralPic}元</span>
                            <CheckboxItem onChange={(e) => this.checkChange(e)}>
                            </CheckboxItem>
                        </div>
                        <div className="discounts youhui" onClick={()=>this.openDiscount()}>
                            <span>优惠券抵扣</span>
                            <span>{this.state.cityDetail.discount}元</span>
                            <i className="icon iconfont icontiaozhuan"/>
                        </div>
                    </div>
                    <div className="btnsw">
                    <div className="btns btn bgc" onClick={()=>Modal.alert('提示',
                        (<div style={{paddingTop:0}}>
                            <div style={{fontSize:16}}>您是否要取消？</div>
                        </div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"46px"}
                        }, {
                            text: '确认',
                            onPress: () => this.cancelCar(this.state.cityOrderid),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"46px"}
                        }]
                    )}><button>取消</button></div>
                    <div className='btnmid'></div> 
                    <div className="btns btn" onClick={()=>this.setState({payModal:true,orderType:0})}><button>支付</button></div>
                    </div>
                </div>
            )
        }
        if(this.state.cayStatus == -1){
            return(
                //先付费样式
                <div className="byCar">
                    <div className='box'>
                        <div className='tit'>请您按预估价支付车费</div>
                        <div className='text'>预先支付无需承担任何风险，行程结束后实际产生费用多退少补。预付款未使用的部分，将立即发起原路退款。如产生附加费，如高速费等，请另行支付。</div>
                        <div className='price'><span>{props.theoryPrice}</span>元</div>
                    </div>
                    
                    <div className="info">
                        <div onClick={()=>this.setState({rideModal:true})}>更换乘车人 <i className="icon iconfont icontiaozhuan"/></div>
                    </div>
                    <div className="btn" onClick={()=>this.goByCar()}><button>去支付</button></div>
                </div>
            )
        }
        if(this.state.cayStatus == 99){
            return(
                <div className="carCall">
                    <div className="title">手续费支付</div>
                    <div className="content">
                        <p className="picText"><span className="pic">{this.state.cityDetail.price}</span> 元</p>
                        <p className="text">取消订单产生手续费</p>
                    </div>
                    <div className="btns btn" onClick={()=>this.setState({payModal:true,orderType:1})}><button>支付</button></div>
                </div>
            )
        }
    }
    changeDiscount(e){
        let cityDetail = this.state.cityDetail;
        let totalPrice = this.state.totalPrice;
        if(cityDetail.discountId == e.id){
            Toast.info("不能选择相同的优惠券",2);
            return
        }
        if(cityDetail.discountId !== e.id){
            if(cityDetail.price < e.useLimitAmount){
                Toast.info("满减金额不足",2);
                return
            }
            if(cityDetail.price >= e.useLimitAmount){
                if(e.couponType == 1 && cityDetail.price/2 >= e.couponAmount){
                    cityDetail.discount = e.couponAmount;
                }
                if(e.couponType == 1 && cityDetail.price/2 < e.couponAmount){
                    cityDetail.discount = cityDetail.price/2;
                }
                if(e.couponType == 2){
                    cityDetail.discount = parseFloat((cityDetail.price*e.discountRatio).toFixed(2));
                }
            }
            if(this.state.integralVal == true){
                if(parseFloat((this.state.cityDetail.price-cityDetail.discount-this.state.integralPrice).toFixed(2)) < 0 ){
                    totalPrice = 0;
                }else{
                    totalPrice = parseFloat((this.state.cityDetail.price-cityDetail.discount-this.state.integralPrice).toFixed(2));
                }
            }else{
                totalPrice = parseFloat((this.state.cityDetail.price-cityDetail.discount).toFixed(2));
            }
            cityDetail.discountId = e.id;
            cityDetail.couponName = e.couponName;
        }
        this.setState({discountsModal:false,cityDetail,totalPrice});
    }
    //优惠券列表
    discountCoupon(){
        return(
            <Modal
                className="discountsModal"
                closable={true}
                popup
                visible={this.state.discountsModal}
                animationType="slide-up"
                onClose={()=>this.setState({discountsModal:false})}
            >
                <div className="discountWrap">
                    <div className="titleText">优惠券</div>
                    <div className="content">
                        <div className="not" onClick={()=>this.nonuse()}>不使用优惠券</div>
                        {
                            this.state.discountList.map((res,i)=>(
                                <div className="list" key={i} onClick={()=>this.changeDiscount(res)}>
                                    <div className="left">
                                        {res.couponType == 1 ? <p className="pic">￥<span>{parseFloat(res.couponAmount).toFixed(2)}</span></p> : <p className="pic"><span>{res.couponRatio * 10}</span> 折</p>}
                                        {res.limitType == 1 ? <p>无限制</p> :<p>满{res.useLimitAmount}可用</p>}
                                    </div>
                                    <div className="right">
                                        <p className="title">{res.couponName}</p>
                                        <p className="time">有效期：{res.allotTime}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Modal>
        )
    };
    //不使用优惠券
    nonuse(){
        let cityDetail = this.state.cityDetail;
        let totalPrice = this.state.totalPrice;
        totalPrice = parseFloat((totalPrice + cityDetail.discount).toFixed(2));
        cityDetail.discount = 0;
        cityDetail.discountId = "";
        cityDetail.couponName = "";
        this.setState({discountsModal:false,cityDetail,totalPrice})
    }
    openDiscount(){
        if(this.state.discountList.length > 0){
            this.setState({discountsModal:true});
        }else if(this.state.discountList.length == 0){
            Toast.info("您没有可用的优惠券")
        }
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        let props = this.props.location.state;
        if(props && props.runType !== undefined){
            if(e == "工商银行支付"){
                this.runPay("icbcjft");
            }
            if(e== "微信支付"){
                this.runPay("wx");
            }
        }else{
            if(e == "工商银行支付"){
                this.goPay(this.state.orderType,"icbcjft");
            }
            if(e== "微信支付"){
                this.goPay(this.state.orderType,"wx");
            }
        }
    }
    runPay(type,){
        let params={
            source:1,
            token: this.props.userInfo.token,
            data:{
                source:1,
                payChannel:type,
                orderId:this.state.runOrderid,
            },
        };
        Toast.loading("",0);
        shuttlePay(params).then((res)=>{
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data,"wxPay","runPay");
                }else{
                    // window.location.href = res.data.data.qrcode;
                    this.setState({formPay:res.data.data});
                }
            } else {
                Toast.info(res.data.msg);
            }
        });
    }
    goPay(orderType,payType){
        let params={
            source:1,
            token: this.props.userInfo.token,
            data:{
                source: 1,
                totalPrice:parseFloat((this.state.totalPrice).toFixed(2)),
                orderType:orderType,
                couponId:this.state.cityDetail.discountId,
                discountPic:this.state.cityDetail.discount,
                integralPrice:this.state.integralPrice,
                orderId:this.state.cityOrderid,
                payChannel:payType,
            },
        };
        Toast.loading("",0);
        cityWxPay(params).then((res)=>{
            console.log(res,orderType,'res,orderType');
            if (res.data.code === '0000') {
                Toast.hide();
                if(orderType == 0){
                    if(this.state.totalPrice > 0 ){
                        if(payType == "wx"){
                            this.wxBridgeReady(res.data.data,"wxPay");
                        }else{
                            this.setState({formPay:res.data.data});
                        }
                    }else{
                        isSubmit = true;
                        this.setState({payModal:false,runOrderid:this.state.cityOrderid});
                        this.getOrderStatus("call");
                    }
                }else{
                    if(payType == "wx"){
                        this.wxBridgeReady(res.data.data);
                    }else{
                        this.setState({formPay:res.data.data});
                    }
                }

            } else {
                Toast.info(res.data.msg);
            }
        });
    }

    wxBridgeReady = (bridgeInfo,type,run) => {
        const self = this;

        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        if(type == "wxPay"){
                            //支付成功跳转评价
                            isSubmit = true;
                            if(run == "runPay"){
                                self.props.history.push(`/pay/myOrder`,);
                            }else{
                                self.props.history.push("/gradeDriver",self.state.cityDetail);
                            }
                        }else{
                            Toast.info("取消成功",2,()=>{self.props.history.goBack()});
                        }
                    } else if (r.err_msg == "get_brand_wcpay_request:fail") {
                        Toast.info('支付失败，请稍后重试');
                    }
                }
            );
        }

        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };
    //倒数计时
    setDownTime(time,cityOrderid) {
        timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({
                    countDown: time,
                });
            } else {
                this.setState({
                    countDown: 0,
                    disabled: true
                });
                clearInterval(timer);
                this.cancelCar(cityOrderid,"countDown");
            }

        }, 1000);
    }
    cancelCar(shuntOrderid,countDown,pic){
        let params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                operatorType:0,
                shuntOrderid:shuntOrderid,
                serviceCharge:pic,
            }
        };
        Toast.loading("",30);
        cancelCityOrder(params).then((res)=>{
            if(res.data.code == "0000"){
                clearInterval(socketTime);
                clearInterval(timer);
                Toast.hide();
                if(countDown == "countDown"){
                    if(window.location.href.split('/')[3] == "rideCar"){
                        Toast.info("您的城内订单超时，已自动取消",2,()=>{this.props.history.go(-2)});
                    }else{
                        Toast.info("您的城内订单超时，已自动取消",2);
                    }
                }else{
                    if(res.data.data.totalPrice > 0){
                        Toast.info("取消成功",2,()=>{this.props.history.goBack()});
                        //this.setState({payModal:true,orderType:1,totalPrice:res.data.data.totalPrice});
                        // this.goPay(1,res.data.data.totalPrice);
                    }else{
                        Toast.info("取消成功",2,()=>{this.props.history.goBack()});
                    }
                }
            }else{
                Toast.info(res.data.msg)
            }
        })
    }
    changeAddress(){
        let params = {
            startCity:this.state.cityDetail.startCity,
            cityType:"cityChange",
            id:this.state.cityDetail.id,
        };
        this.props.history.push('/selAddress',params);
    }
    getCancelPrice(){
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                shuntOrderid:this.state.cityOrderid,
            },
        };
        getCancelPic(params).then((res)=>{
            if(res.data.code == "0000"){
                Modal.alert('提示',
                    (<div style={{paddingTop:0}}>
                        <div>您是否确认取消本次订单？</div>
                        <div style={{color:"#616372",fontWeight:"initial"}}>本次主动取消订单将收取  <span style={{color:"#F79E24"}}>{res.data.data + "元"}</span>手续费 </div>
                    </div>),
                    [{
                        text: '取消',
                        style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"46px"}
                    }, {
                        text: '确认',
                        onPress: () => {
                           this.cancelCar(this.state.cityOrderid,'',res.data.data)
                        },
                        style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"46px"}
                    }]
                )
            }else{
                Toast.info(res.data.msg)
            }
        });

    }
    checkChange(e){
        let totalPrice = this.state.totalPrice;
        let integral = this.state.cityDetail.integralPic;
        let integralPic = 0;
        if(this.state.cityDetail.integralCount-integral < 0){
            integral = this.state.cityDetail.integralCount
        }
        if(e.target.checked === true){
            integralPic = integral;
            if(parseFloat((totalPrice-integral).toFixed(2)) < 0 ){
                totalPrice = 0;
            }else{
                totalPrice =parseFloat((totalPrice-integral).toFixed(2));
            }
        }else if(e.target.checked === false){
            integralPic = 0;
            totalPrice =parseFloat((this.state.cityDetail.price-this.state.cityDetail.discount).toFixed(2));
        }
        this.setState({integralVal:e.target.checked,totalPrice,integralPrice:integralPic});
    }
    payClose = () => {
        let props = this.props.location.state;
        if(props && props.runType !== undefined){
            Toast.info('您取消了支付，可到订单详情支付', 2, () => {
                this.props.history.push(`/pay/myOrder`,);
            });
            isSubmit = true;
        }else{
            this.setState({payModal:false});
        }
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    changePhone(){
        if(this.state.phoneVal == ''){
            Toast.info("请输入手机号码",3);
            return
        }
        this.setState({phoneModal:false,})
    }
    render(){
        let props = this.props.location.state;
        return(
            <div className="rideCar">
                <div className="content">
                    <div id="mapContainer" style={this.state.mapLoad ? {height:"100%"}: {height:"62%"}}/>
                    {this.state.cayStatus == 7 || this.state.cayStatus == 99 ?  null : <div className="goback"><i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/></div>}
                    {this.cayStatus()}
                    {
                        props == undefined ?  null : props.runType == undefined ? null :(
                            <div className="runBox">
                                <div className="title">
                                    {
                                        this.state.carType.map((res,i)=>(
                                            <span key={i} className={this.state.tabIndex == i ? "titleSel": null}  onClick={()=>this.setState({tabIndex:i,})}>{res.name}</span>
                                        ))
                                    }
                                </div>

                                <div className="pic">
                                    <img src={this.state.carType[this.state.tabIndex].imgUrl}/>
                                    <div className="right">
                                        <div>总计  <span className="price">¥{this.state.carType[this.state.tabIndex].price}</span></div>
                                        <p>最多乘坐 <span>{this.state.carType[this.state.tabIndex].seatNum}人</span>（含儿童）</p>
                                    </div>

                                </div>
                                <div className="info">
                                    <div onClick={()=>{
                                        this.setState({phoneModal:true,});
                                    }}>更换联系号码 <i className="icon iconfont icontiaozhuan"/></div>
                                </div>
                                <div className="btn" onClick={()=>this.goByCar("run")}><button>确认约车</button></div>
                            </div>
                        )
                    }
                </div>
                <Modal
                    visible={this.state.phoneModal}
                    className="phoneModal"
                    transparent
                    maskClosable={false}
                >
                    <div className="title">
                        <span>更改联系号码</span>
                        <i className="icon iconfont iconguanbi" onClick={()=>this.setState({phoneModal:false})}/>
                    </div>
                    <InputItem
                        type='number'
                        placeholder="请输入手机号"
                        clear
                        className="inp"
                        onChange={(v)=>this.setState({phoneVal: v,})}
                        value={this.state.phoneVal}
                        ref={el => this.inputRef = el}
                        maxLength={11}
                    >

                    </InputItem>
                    <p>更改号码仅本次订单联系使用，若需要更 改绑定号码请到个人中心绑定。</p>
                    <button onClick={()=>this.changePhone()}>确认更改</button>
                </Modal>
                <Modal
                    visible={this.state.rideModal}
                    animationType="slide-up"
                    className="rideModal"
                    popup
                >
                    <NavBar
                        className="navBar"
                        mode="light"
                        icon={<i className="icon iconfont iconfanhui" onClick={this.onClose("rideModal")} />}
                    >乘车人信息</NavBar>
                    <div className="contentBox">
                        <div className="top">
                            <p className="tit">乘车人</p>
                            <div className="nameBox">
                                <InputItem
                                    clear
                                    placeholder="姓名(选填)"
                                    value={this.state.name}
                                    onChange={v => this.inputChange(v, 'name')}
                                    onBlur={v => window.scroll(0,0)}
                                    className="name"
                                >
                                    <i className="icon iconfont iconpeople"/>
                                </InputItem>
                                <div className="relation" onClick={()=>this.setState({selPsgModal:true})}>常用联系人<i className="icon iconfont icontiaozhuan"/></div>
                            </div>
                            <InputItem
                                clear
                                type="number"
                                placeholder="手机号"
                                maxLength={11}
                                value={this.state.phone}
                                onChange={v => this.inputChange(v, 'phone')}
                                onBlur={v => window.scroll(0,0)}
                            ><i className="icon iconfont iconlianxishouji"/></InputItem>
                            <div className="tishji">该笔订单费用由您支付，订车成功后系统将给乘车人发送短 信通知</div>
                        </div>
                        <div  className="btn" >
                            <p>未成年人乘车需由监护人陪同，乘车人行程中违反平台规则，代叫车需承担连带责任</p>
                            <div className="xieyi" onClick={() => this.setState({agreementModal:true})}>《民途出行用户协议》</div>
                            <div onClick={()=>this.submitInfo()}><button>确认代叫</button></div>
                        </div>

                    </div>
                    <AgreementModal
                        modal={this.state.agreementModal}
                        onClose={this.agreementClose.bind(this)}
                    />
                    {this.selPsg()}
                </Modal>
                {this.discountCoupon()}
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.payClose.bind(this)}
                    payType={this.payType.bind(this)}
                />
                {this.payFrom()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/RideCar/index.js